import { render } from "./change-realname.vue?vue&type=template&id=f4c60a28&scoped=true"
import script from "./change-realname.vue?vue&type=script&lang=js"
export * from "./change-realname.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4c60a28"]])

export default __exports__